/* eslint-disable react/prop-types */
import { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Card,
  CircularProgress,
} from "@mui/material";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftBox from "components/SoftBox";
import { AccountingSystemService } from "services/accountingSystemService";

/* ===== FLATTEN DATA ===== */
const buildRows = (groups = []) => {
  const rows = [];

  groups.forEach((group) => {
    rows.push({
      type: "TITLE",
      label: group.typeAccount,
    });

    group.rows.forEach((r) => {
      rows.push({
        type: "DATA",
        ...r,
      });
    });
  });

  return rows;
};

export default function AccountingAccountsTT133() {
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await AccountingSystemService.getAll({ idTT: 1 });
      const raw = res?.data?.items || res?.data || [];
      setGroups(Array.isArray(raw) ? raw : []);
    } catch (e) {
      console.error(e);
      setGroups([]);
    } finally {
      setLoading(false);
    }
  };

  const rows = useMemo(() => buildRows(groups), [groups]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card>
          {loading ? (
            <SoftBox p={3} textAlign="center">
              <CircularProgress />
            </SoftBox>
          ) : (
            <Table
              size="small"
              sx={{
                tableLayout: "fixed",
                width: "100%",
              }}
            >
              {/* ===== FIX WIDTH CỘT ===== */}
              <colgroup>
                <col style={{ width: 100 }} />
                <col style={{ width: 120 }} />
                <col style={{ width: 100 }} />
                <col style={{ width: 120 }} />
                <col style={{ width: 420 }} />
              </colgroup>

              {/* ===== BODY ===== */}
              <TableBody>
                <TableRow>
                  <TableCell align="center" sx={{ fontWeight: 700 }}>
                    Số TT
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: 900 }}>
                    Cấp 1
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: 900 }}>
                    Cấp 2
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: 900 }}>
                    Hỗ trợ SME
                  </TableCell>
                  <TableCell align="left" sx={{ fontWeight: 900 }}>
                    Tên tài khoản
                  </TableCell>
                </TableRow>
                {rows.map((row, idx) => {
                  /* ===== TITLE ROW ===== */
                  if (row.type === "TITLE") {
                    return (
                      <TableRow key={`title-${idx}`}>
                        <TableCell
                          sx={{
                            fontWeight: 700,
                            textTransform: "uppercase",
                            backgroundColor: "#f9fafb",
                          }}
                        />
                        <TableCell
                          sx={{
                            fontWeight: 700,
                            textTransform: "uppercase",
                            backgroundColor: "#f9fafb",
                          }}
                        />
                        <TableCell
                          sx={{
                            fontWeight: 700,
                            textTransform: "uppercase",
                            backgroundColor: "#f9fafb",
                          }}
                        />
                        <TableCell
                          sx={{
                            fontWeight: 700,
                            textTransform: "uppercase",
                            backgroundColor: "#f9fafb",
                          }}
                        />
                        <TableCell
                          sx={{
                            fontWeight: 700,
                            textTransform: "uppercase",
                            backgroundColor: "#f9fafb",
                          }}
                        >
                          {row.label}
                        </TableCell>
                      </TableRow>
                    );
                  }

                  /* ===== DATA ROW ===== */
                  const isLevel1 = row.level === 1;

                  return (
                    <TableRow key={row.accountCode}>
                      {/* SỐ TT */}
                      <TableCell align="center">{row.idNumber || ""}</TableCell>

                      {/* CẤP 1 */}
                      <TableCell align="center" sx={{ fontWeight: isLevel1 ? 700 : 400 }}>
                        {isLevel1 ? row.accountCode : ""}
                      </TableCell>

                      {/* CẤP 2 */}
                      <TableCell align="center">{!isLevel1 ? row.accountCode : ""}</TableCell>
                      {/* SME */}
                      <TableCell
                        align="center"
                        sx={{
                          fontWeight: 600,
                          color: row?.isSMESupported ? "success.main" : "error.main",
                        }}
                      >
                        {row?.isSMESupported ? "Có" : "Không"}
                      </TableCell>

                      {/* TÊN */}
                      <TableCell
                        sx={{
                          fontWeight: row.typeBold ? 700 : 400,
                          pl: !isLevel1 ? 2 : 0,
                        }}
                      >
                        {row.nameAccount}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          )}
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}
